export default {
  BalanceTransferYear: 1, // Kết chuyển số dư cuối năm
  PerformanceResultDefined: 4, // Xác định kết quả hoạt động
};
